module.exports = __webpack_public_path__ + "static/media/apartment16.01bffab0.jpg";